/* One continuous gas-log form. Native controls, images, prices and validation remain authoritative. */
(function () {
  'use strict';
  function init() {
    var host = document.querySelector('.ef-lab-gas-purchase');
    var root = host && host.querySelector('#efOf');
    if (!root || root.dataset.efFamilyLayout === 'continuous') return;
    root.dataset.efFamilyLayout = 'continuous';
    root.dataset.efFamilyFlow = 'ready';
    root.classList.add('ef-family-flow', 'ef-family-flow--gas');
    root.querySelectorAll('.ef-of__cd').forEach(function (detail) {
      delete detail.dataset.efLabInlineFuel;
      detail.open = false;
    });
    var intro = root.querySelector('.ef-of__head--intro');
    if (intro) intro.hidden = true;
    var head = document.createElement('header');
    head.className = 'ef-family-flow__header';
    var title = document.createElement('h2');
    title.className = 'ef-family-flow__title';
    var sphereSet = window.EF_GL && window.EF_GL[root.dataset.productHandle] && window.EF_GL[root.dataset.productHandle].media === 'spheres';
    var firePitSet = root.dataset.productHandle === '24-fire-pit-gas-log-set-formation-creation';
    title.textContent = firePitSet ? 'Configure Your Fire Pit Kit' : (sphereSet ? 'Configure Your Fyre Spheres' : 'Configure Your Gas Logs');
    if (firePitSet) {
      var indoorGuide = root.querySelector('#efOfGuideBtn'); if (indoorGuide) indoorGuide.hidden = true;
      var photoLegend = root.querySelector('.ef-of__field--photo legend'); if (photoLegend) photoLegend.innerHTML = 'Fire pit photos <span class="ef-of__legend-opt">· optional</span>';
    }
    var hint = document.createElement('p');
    hint.className = 'ef-family-flow__hint';
    hint.textContent = 'Choose your size and options below. Your total updates as you go.';
    var eyebrow = document.createElement('span');
    eyebrow.className = 'ef-family-flow__eyebrow';
    eyebrow.textContent = 'Configurator · Step-by-step';
    head.append(eyebrow, title); root.prepend(head);
    var retouched = document.querySelector('#efGallerySwiper img[alt*="AI-retouched product view"]');
    var galleryEnd = document.getElementById('efThumbWrap') || document.getElementById('efGallerySwiper');
    if (retouched && galleryEnd && !document.querySelector('[data-ef-photo-retouch]')) {
      var imageNote = document.createElement('p'); imageNote.setAttribute('data-ef-photo-retouch','');
      imageNote.style.cssText='font:400 13px/1.5 var(--efx-font,"DM Sans",sans-serif);color:#55524c;margin:12px 0 0;';
      imageNote.textContent='AI-retouched product view. Original reference included.';
      galleryEnd.after(imageNote);
    }

    var express = root.querySelector('#efOfExpressCheckout');
    var payment = host.querySelector('[data-ef-family-payment]');
    if (express && payment) express.after(payment);
    var share = root.querySelector('#efOfShareCfg');
    if (share && payment) payment.after(share);
    var photoHint = root.querySelector('.ef-of__hint--photo');
    if (photoHint && firePitSet) photoHint.textContent = 'Add a photo of your outdoor fire pit with a tape measure across the opening, plus your gas supply details.';
    if (photoHint && !firePitSet) photoHint.textContent = 'Add photos of the full firebox and the model label, if available. Show a tape measure at the front width, rear width, depth and height to help our team review your setup.';
    var sizeField = root.querySelector('.ef-of__field--gl-size');
    if (sizeField) {
      var sizeHint = sizeField.querySelector('[data-ef-lab-hint="sizes"]');
      if (!sizeHint) { sizeHint = document.createElement('p'); sizeHint.className = 'ef-lab-order-hint'; sizeHint.dataset.efLabHint = 'sizes'; sizeField.querySelector('legend').after(sizeHint); }
      sizeHint.textContent = sphereSet ? 'Choose your sphere set size.' : 'Choose your log set size.';
      requestAnimationFrame(function () { requestAnimationFrame(function () {
        var rail = sizeField.querySelector('.efg-size-thumbs'), selected = sizeField.querySelector('.efg-size-thumb.is-active');
        if (rail && selected && matchMedia('(max-width:599px)').matches) {
          var a = selected.getBoundingClientRect(), b = rail.getBoundingClientRect();
          rail.scrollLeft += a.left - b.left - (b.width - a.width) / 2;
        }
      }); });
    }
    var photoField = root.querySelector('.ef-of__field--photo');
    if (photoField) {
      var optional = photoField.querySelector('.ef-of__legend-opt');
      if (optional) optional.textContent = '· optional';
      var tips = photoField.querySelector('.ef-of__phototips-card');
      if (tips) tips.remove();
      var box = photoField.querySelector('#efOfFileDropBox');
      if (box) { var layout = document.createElement('div'); layout.className = 'ef-gas-photo-layout'; box.before(layout); layout.append(box); }
      var divider = photoField.querySelector('.ef-of__field-rule'); if (divider) divider.remove();
    }
    var drop = root.querySelector('#efOfFileDrop');
    if (drop) drop.addEventListener('keydown', function (event) {
      if (event.target === drop && (event.key === 'Enter' || event.key === ' ')) { event.preventDefault(); root.querySelector('#efOfFile').click(); }
    });
    var warrantyLink = document.querySelector('[data-ef-gas-warranty]');
    if (warrantyLink) warrantyLink.addEventListener('click', function (event) {
      var item = Array.from(document.querySelectorAll('.ef-gas-product-details details,.ef-uni-acc details')).find(function (d) { return /warranty/i.test((d.querySelector('summary') || {}).textContent || ''); });
      if (!item) return;
      event.preventDefault(); item.open = true; item.scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      var summary = item.querySelector('summary'); if (summary) summary.focus({preventScroll:true});
    });
    var install = root.querySelector('.ef-of__install-conf');
    if (install) {
      install.querySelector('.ef-of__ic-head').textContent = 'Installation & fit support';
      var points = install.querySelectorAll('.ef-of__ic-list li > span');
      if (points[0]) points[0].textContent = 'Have your gas log set installed by a qualified professional.';
      if (points[1]) points[1].textContent = 'Our team reviews size, fuel and ignition before shipping.';
      if (points[2]) points[2].innerHTML = 'Need help? <a href="tel:+19496197824">Call (949) 619-7824</a> or add a photo above.';
    }
    var proof = document.querySelector('.ef-gas-reviews');
    var wall = proof && proof.querySelector('#looxReviews');
    if (wall && !wall.closest('[data-efx-loox]')) {
      var fold = document.createElement('div'); fold.className = 'efx-pdp__loox efx-pdp__loox--capped'; fold.dataset.efxLoox = '';
      wall.before(fold); fold.append(wall);
      var more = document.createElement('p'); more.className = 'efx-pdp__looxmore';
      var button = document.createElement('button'); button.type = 'button'; button.className = 'efx-btn efx-btn--ghost';
      button.setAttribute('aria-expanded', 'false'); button.setAttribute('aria-controls', 'looxReviews'); button.textContent = 'Show more reviews';
      function revealReviews() {
        if (fold.classList.contains('is-open')) return;
        fold.classList.add('is-open');
        button.setAttribute('aria-expanded', 'true');
        more.hidden = true;
        if (document.activeElement === button) {
          wall.tabIndex = -1;
          wall.focus({ preventScroll: true });
        }
      }
      function revealFocusedReviews() {
        if (wall.contains(document.activeElement)) revealReviews();
      }
      button.addEventListener('click', revealReviews);
      wall.addEventListener('focusin', revealFocusedReviews);
      window.addEventListener('blur', function () { setTimeout(revealFocusedReviews, 0); });
      more.append(button); fold.append(more);
    }
    var notes = root.querySelector('#efOfNotes');
    if (notes) notes.placeholder = 'Anything we should know about your fireplace or installation?';
    // Continuous Gas Logs keeps its native purchase/validation. This bar mirrors
    // the native total and busy/availability state, then delegates to that button.
    var nativeAtc = root.querySelector('#efOfAtc');
    var nativeLabel = nativeAtc && nativeAtc.querySelector('.ef-of__atc-label');
    if (nativeAtc && nativeLabel && !document.querySelector('#efPd2Sticky,.ef-gas-sticky')) {
      var gasBar = document.createElement('aside');
      gasBar.className = 'ef-gas-sticky'; gasBar.setAttribute('aria-label', 'Gas log price and order');
      gasBar.innerHTML = '<div class="ef-gas-sticky__inner"><strong class="ef-gas-sticky__price"></strong><a class="ef-gas-sticky__call" href="tel:+19496197824" aria-label="Call ExceptionalFire at (949) 619-7824"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><path d="M22 16.92v3a2 2 0 0 1-2.18 2A19.79 19.79 0 0 1 11.19 19a19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-2.91-8.67A2 2 0 0 1 4.26 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.69 2.79a2 2 0 0 1-.45 2.11L8.23 9.89a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.89.33 1.83.56 2.79.69A2 2 0 0 1 22 16.92z"/></svg><span>(949) 619-7824</span></a><button type="button" class="ef-gas-sticky__action"></button></div>';
      (host.closest('.ef-lab-gas-page') || host).append(gasBar);
      var barPrice = gasBar.querySelector('.ef-gas-sticky__price'), barAction = gasBar.querySelector('.ef-gas-sticky__action');
      var normalLabel = nativeLabel.textContent, ownedLabel = '', firstMissing = null;
      function gasMissingChoice() {
        return Array.from(root.querySelectorAll('.ef-of__cd[data-required="true"]')).find(function(d) {
          var f = d.closest('fieldset');
          if (d.dataset.selected === 'true' || !f || f.closest('[hidden]')) return false;
          for (var n=f; n; n=n.parentElement) { if (getComputedStyle(n).display === 'none') return false; if(n===root)break; }
          return true;
        }) || null;
      }
      function gasChoiceName(d) {
        var names={fuel:'fuel',ignition:'ignition',burner:'burner'};if(names[d.dataset.group])return names[d.dataset.group];
        var legend=d.closest('fieldset').querySelector('legend'),copy=legend&&legend.cloneNode(true);
        if(copy)copy.querySelectorAll('.ef-of__legend-num,.ef-fireplace-required').forEach(function(n){n.remove();});
        return (copy?copy.textContent:d.dataset.group||'option').replace(/^\s*\d+\s*/,'').replace(/\s*Required\s*$/i,'').trim().toLowerCase();
      }
      function syncGasBar() {
        firstMissing=gasMissingChoice();
        var engineLabel=nativeLabel.textContent;
        var nativeBusy=nativeAtc.getAttribute('aria-busy')==='true';
        var mayGuide=!nativeBusy&&(engineLabel===normalLabel||engineLabel===ownedLabel);
        if(mayGuide){var wanted=firstMissing?'Choose your '+gasChoiceName(firstMissing):normalLabel;if(nativeLabel.textContent!==wanted)nativeLabel.textContent=wanted;ownedLabel=firstMissing?wanted:'';}
        if(barAction.textContent!==nativeLabel.textContent)barAction.textContent=nativeLabel.textContent;
        barAction.disabled=nativeBusy||(!!nativeAtc.disabled&&!(firstMissing&&mayGuide));
        barAction.setAttribute('aria-busy',String(nativeBusy));
        var totalText=root.querySelector('#efOfTotalAmt')?.textContent||'';
        if(barPrice.textContent!==totalText)barPrice.textContent=totalText;
      }
      barAction.addEventListener('click',function(){
        syncGasBar();if(barAction.disabled)return;
        nativeAtc.click();
        if(firstMissing){
          for(var n=firstMissing;n&&n!==root;n=n.parentElement)if(n.tagName==='DETAILS')n.open=true;
          firstMissing.scrollIntoView({block:'center',behavior:'auto'});
          firstMissing.querySelector('summary')?.focus({preventScroll:true});
        }
      });
      var gasSyncQueued=false;
      new MutationObserver(function(){if(gasSyncQueued)return;gasSyncQueued=true;requestAnimationFrame(function(){gasSyncQueued=false;syncGasBar();});}).observe(root,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['data-required','data-selected','hidden','style','disabled','aria-busy']});
      new ResizeObserver(function(){document.documentElement.style.setProperty('--ef-gas-sticky-height',gasBar.offsetHeight+'px');}).observe(gasBar);
      syncGasBar();
    }

    // No inputs or purchase handlers are replaced; native dropdowns remain compact.
    // The guidance script respects ready forms and preserves their option photography.
    var details = document.querySelector('.ef-gas-product-details');
    if (details) {
      var hints = {'Overview':'Product details and key features','Burner & Ignition Guide':'Compare burners and controls','Specifications':'Dimensions and materials','Installation & Log Placement':'Setup and log placement','Warranty':'Coverage for this product','Safety & Compliance':'Before installation and use'};
      details.querySelectorAll('.efgt__item').forEach(function (item) {
        item.open = false;
        var summary = item.querySelector('summary'), label = item.querySelector('.efgt__label');
        if (summary && label && hints[label.textContent.trim()] && !summary.querySelector('.ef-gas-detail-hint')) {
          var text = document.createElement('span'); text.className = 'ef-gas-detail-hint';
          text.textContent = hints[label.textContent.trim()]; summary.insertBefore(text, summary.lastElementChild);
        }
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
